/**
 * Handle quiz conditions
 * @param {number} activeStep - the current active step
 * @param {number} activeSubStep - the current active sub step
 * @param {object} steps - the all steps object
 * @param {object} state - the current state object
 * @returns {Promise<{activeStep: number, activeSubStep: number}>} Promise object represents new steps
 */
const quizConditionsOnNext = async (activeStep, activeSubStep, steps, state) => {
  const products = window.quizData.products;
  /**
   * Handle the fragrance condition
   */
  const handleFragrance = () => {
    const {whatDoYouWantYourShampooToSmellLike} = state;
    const {whatDoYouWantYourConditionerToSmellLike} = state;

    if (state.whatCombinationOfProductsDoYouWantToBuy === products.SHAMPOO_AND_CONDITIONER.label) {
      if (whatDoYouWantYourShampooToSmellLike === 'No fragrance' && whatDoYouWantYourConditionerToSmellLike === 'No fragrance') {
        activeSubStep++;
      }

      return;
    }

    if (isProductChosen(products.CONDITIONER.label) && whatDoYouWantYourConditionerToSmellLike === 'No fragrance') {
      activeStep = 4;
      activeSubStep = 4;

      return;
    }

    if (isProductChosen(products.SHAMPOO.label) && whatDoYouWantYourShampooToSmellLike === 'No fragrance') {
      activeStep = 4;
      activeSubStep = 3;

      return;
    }
  };

  /**
   * Handle the formulation mode condition and set new steps
   */
  const handleFormulationMode = () => {
    if (
      state.chooseHowYoudLikeToFormulateYourPreworkout !== 'Quiz me'
      || state.doYouWantAStimulantcontainingPreworkout === 'No'
    ) {
      activeStep = 3;
      activeSubStep = 0;
    }
  };

  /**
   * Checks if the chosen product matches the specified one.
   *
   * @param {string} product - The product name.
   * @returns {boolean} - True if the product matches or false otherwise.
   */
  const isProductChosen = (product) => {
    return state.whatCombinationOfProductsDoYouWantToBuy === products.SHAMPOO_AND_CONDITIONER.label || state.whatCombinationOfProductsDoYouWantToBuy === product;
  };

  /**
   * Updates the active sub step if the chosen product does not match the specified smell.
   *
   * @param {string} product - The product name.
   */
  const handleProductSmellLike = (product) => {
    if (isProductChosen(product)) {
      return;
    }

    activeSubStep++;

    let nextHeading = steps[activeStep].steps[activeSubStep].heading;
    if (nextHeading === 'How strong do you like your fragrance?') {
      handleFragrance();
    }
  };

  /**
   * Changes the handling of the product colour based on the given product.
   *
   * @param {string} product - The product name.
   */
  const handleProductColour = (product) => {
    if (isProductChosen(product)) {
      return;
    }

    if (product === products.SHAMPOO.label) {
      activeSubStep++;
    } else if (product === products.CONDITIONER.label) {
      activeStep = 5;
      activeSubStep = 0;
    }
  };

  const nextStepHeading = steps[activeStep].steps[activeSubStep].heading;

  // Check conditions based on next step headings
  switch (nextStepHeading) {
    case 'How strong do you like your fragrance?':
      handleFragrance();
      break;
    case 'What types of exercise will you use your pre-workout for?':
    case 'How much do you weigh?':
      handleFormulationMode();
      break;
    case 'What do you want your shampoo to smell like?':
      handleProductSmellLike(products.SHAMPOO.label);
      break;
    case 'What do you want your conditioner to smell like?':
      handleProductSmellLike(products.CONDITIONER.label);
      break;
    case 'What colour do you want your shampoo to be?':
      handleProductColour(products.SHAMPOO.label);
      break;
    case 'What colour do you want your conditioner to be?':
      handleProductColour(products.CONDITIONER.label);
      break;
    default:
      break;
  }

  return {
    activeStep,
    activeSubStep,
  };
};

/**
 * Handle quiz conditions
 * @param {number} activeStep - the current active step
 * @param {number} activeSubStep - the current active sub step
 * @param {string} nextStepHeading - the heading of the next step
 * @param {object} state - the current state object
 * @returns {Promise<{activeStep: number, activeSubStep: number}>} Promise object represents new steps
 */

const quizConditionsOnBack = async (activeStep, activeSubStep, nextStepHeading, state) => {
  const products = window.quizData.products;

  /**
   * Handle the fragrance condition
   */
  const handleFragrance = () => {
    const {whatDoYouWantYourShampooToSmellLike} = state;
    const {whatDoYouWantYourConditionerToSmellLike} = state;

    if (state.whatCombinationOfProductsDoYouWantToBuy === products.SHAMPOO_AND_CONDITIONER.label) {
      if (whatDoYouWantYourShampooToSmellLike === 'No fragrance' && whatDoYouWantYourConditionerToSmellLike === 'No fragrance') {
        activeSubStep--;
      }

      return;
    }

    if (isProductChosen(products.CONDITIONER.label) && whatDoYouWantYourConditionerToSmellLike === 'No fragrance') {
      activeStep = 4;
      activeSubStep = 1;

      return;
    }

    if (isProductChosen(products.SHAMPOO.label) && whatDoYouWantYourShampooToSmellLike === 'No fragrance') {
      activeStep = 4;
      activeSubStep = 0;

      return;
    }
  };

  /**
   * Handle the formulation mode condition and set new steps
   */
  const handleFormulationMode = () => {
    if (data.chooseHowYoudLikeToFormulateYourPreworkout !== 'Quiz me') {
      activeStep = 0;
      activeSubStep = 4;
    }

    if (data.doYouWantAStimulantcontainingPreworkout === 'No') {
      activeStep = 2;
      activeSubStep = 0;
    }
  };

  /**
   * Checks if the chosen product matches the specified one.
   *
   * @param {string} product - The product name.
   * @returns {boolean} - True if the product matches or false otherwise.
   */
  const isProductChosen = (product) => {
    return state.whatCombinationOfProductsDoYouWantToBuy === products.SHAMPOO_AND_CONDITIONER.label || state.whatCombinationOfProductsDoYouWantToBuy === product;
  };

  /**
   * Updates the active sub step if the chosen product does not match the specified smell.
   *
   * @param {string} product - The product name.
   */
  const handleProductSmellLike = (product) => {
    if (isProductChosen(product)) {
      return;
    }

    if (product === products.SHAMPOO.label) {
      activeStep = 3;
      activeSubStep = 0;
    }
    else {
      activeSubStep--;
    }
  };

  /**
   * Changes the handling of the product colour based on the given product.
   *
   * @param {string} product - The product name.
   */
  const handleProductColour = (product) => {
    if (state.whatCombinationOfProductsDoYouWantToBuy === products.SHAMPOO_AND_CONDITIONER.label) {
      return;
    }

    if (product === products.SHAMPOO.label && state.whatCombinationOfProductsDoYouWantToBuy === products.CONDITIONER.label) {
      activeSubStep--;
      handleFragrance();
    } else if (product === products.CONDITIONER.label && state.whatCombinationOfProductsDoYouWantToBuy === products.SHAMPOO.label) {
      activeStep = 4;
      activeSubStep = 3;
    }
  };

  // Check conditions based on next step headings
  switch (nextStepHeading) {
    case 'How strong do you like your fragrance?':
      handleFragrance();
      break;
    case 'What types of exercise will you use your pre-workout for?':
    case 'How much do you weigh?':
      handleFormulationMode();
      break;
    case 'What do you want your shampoo to smell like?':
      handleProductSmellLike(products.SHAMPOO.label);
      break;
    case 'What do you want your conditioner to smell like?':
      handleProductSmellLike(products.CONDITIONER.label);
      break;
    case 'What colour do you want your shampoo to be?':
      handleProductColour(products.SHAMPOO.label);
      break;
    case 'What colour do you want your conditioner to be?':
      handleProductColour(products.CONDITIONER.label);
      break;
    case 'Choose a charity.':
      break;
    default:
      break;
  }

  return {
    activeStep,
    activeSubStep,
  };
}

export {quizConditionsOnNext, quizConditionsOnBack};
